<template>
    <modal :allowCancel="false"
            @closed="closeModal()">
        <div class="content">
            <h2 class="content--text">{{$t('DELIVERY_SKIP_REASON_TEXT')}}</h2>
            <div class="content--radio">
                <radio-field
                    v-for="reason in skipReasons"
                    :key="reason.id"
                    :label="reason.name"
                    :option="reason.id+''"
                    v-model="reasonId"/>
            </div>
        </div>
        <button
            slot="actions-prefix"
            class="btn btn--primary"
            @click="sendReason">{{$t('DELIVERY_SKIP_REASON_BUTTON')}}</button>
    </modal>
</template>

<script>
import Modal from '@/components/structure/Modal';
import RadioField from '@/components/forms/fields/RadioField';

export default {
    name: 'DeliverySkipReasonModal',
    components: { Modal, RadioField },
    props: {
        skipReasons: {
            require: true,
            default: [],
        },
        skippedData: {
            require: true,
        },
    },
    data() {
        return {
            reasonId: null,
        };
    },
    methods: {
        closeModal() {
            this.$emit('closed');
        },
        sendReason() {
            let subscriptionId = this.skippedData.subscriptionId;
            let payload = {
                skipping_delivery_reason_id: Number(this.reasonId),
                delivery_date: this.skippedData.deliveryDate,
            };
            this.$store.dispatch('account/sendSkipDeliveryReasons', { subscriptionId, payload });
            this.closeModal();
        },
    },
};
</script>

<style lang="scss" scoped>
.content {
    max-width: 500px;
    margin: 10px auto;
    &--text {
        text-align: center;
        font-size: 30px;
    }
    &--radio {
        width: 80%;
        margin: 20px auto;
    }
    &--options {
        font-weight: 200;
        label {
            margin-left: 10px;
        }
    }
}
</style>
